<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  <a
    mat-tab-link
    [ngClass]="{'active': supportTab === currentTabName}"
    *ngFor="let supportTab of supportTabNames"
    (click)="tabChanged(supportTab)"  
  >
    {{ supportTab }}
  </a>
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
<router-outlet></router-outlet>
